export default "__VITE_ASSET__DiGUT4fy__"